module.exports = __webpack_public_path__ + "img/about.7df1212f.png";